module.exports = __webpack_public_path__ + "img/southeast-summer-1920x550.d2a6b214.jpg";